import React, { useState, useEffect } from 'react'
import { TextField } from '@material-ui/core';
import $ from 'jquery';
import 'jquery-mask-plugin/dist/jquery.mask.min.js'
import { v4 as uuidv4 } from "uuid";

export const InputMask = (props) => {
  const uuid = uuidv4();
  const [ componentProps ] = useState({
    ...props,
    id: props.id || uuid,
    name: props.id || uuid,
    type: "text"
  })
   
  useEffect(() => {
    $(`input[name=${props.id || uuid}]`).mask(props.mask, {reverse: props.reverse || false});
  }, [])

  return (
    <TextField 
      { ...componentProps }
    />
  )
}
